import React from "react";
import PropTypes from "prop-types";
import { Box, Checkbox, FormControlLabel, Typography } from "@material-ui/core";

import { classificationLabel } from "../../../utils/rulesApi";
import { useRuleStyles } from "../styles";

const FLAGS = [
  { name: "novice", label: "Novice" },
  { name: "synchro", label: "Synchro" },
  { name: "masters", label: "Masters" },
];

/**
 * The three exact-match flags of a rule set. Meet setup compares all three with the event, so
 * "off" is as much a restriction as "on"; the help line spells out what the current combination
 * matches.
 */
const ClassificationToggles = ({ value, onChange, disabled }) => {
  const classes = useRuleStyles();
  const label = classificationLabel(value);
  const summary =
    label === "Standard"
      ? "standard events only (not novice, not synchro, not masters)"
      : `${label.toLowerCase()} events only`;

  return (
    <Box
      component="fieldset"
      className={classes.classification}
      style={{ border: 0, padding: 0, margin: 0 }}
      aria-describedby="classification-help"
    >
      <Typography component="legend" className={classes.paneTitle}>
        Event classification
      </Typography>
      {FLAGS.map((flag) => (
        <FormControlLabel
          key={flag.name}
          control={
            <Checkbox
              color="primary"
              checked={Boolean(value[flag.name])}
              disabled={disabled}
              onChange={(e) =>
                onChange({ ...value, [flag.name]: e.target.checked })
              }
            />
          }
          label={flag.label}
        />
      ))}
      <Typography id="classification-help" className={classes.inlineHelp}>
        Matches <strong>{summary}</strong>. Meet setup matches all three flags
        exactly: a Novice + Synchro set is offered only to novice synchro
        events.
      </Typography>
    </Box>
  );
};

ClassificationToggles.propTypes = {
  value: PropTypes.shape({
    novice: PropTypes.bool,
    synchro: PropTypes.bool,
    masters: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ClassificationToggles.defaultProps = { disabled: false };

export default ClassificationToggles;
